import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Card, Form, Table, Button, Row, Col } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";
import { debounce } from 'lodash';
import Select from 'react-select';
import { BASE_URL } from "../../services/Api";
import { authHeader } from "../../services/auth-header";

const BomPumpCreate = () => {
  const navigate = useNavigate();
  const [finishedproductOptions, setfinishedproductOptions] = useState([]);
  const [finishedproductSearch, setfinishedproductSearch] = useState(encodeURIComponent(" "));
  const [selectedfinishedproduct, setSelectedfinishedproduct] = useState(null);
  const [productTableRaw, setproductTableRaw] = useState([]);
  const [selectedPumpRawSemiProduct, setSelectedPumpRawSemiProduct] = useState(null);
  const [PumpRawSemiProductSearch, setPumpRawSemiProductSearch] = useState("");
  const [PumpRawSemiProductOptions, setPumpRawSemiProductOptions] = useState([]);
  const [labourcharges, setlabourcharges] = useState('');
  const [partno, setpartno] = useState('');
  const [size, setsize] = useState('');

  const [jobnumber, setjobnumber] = useState("");
  const [enquiryValidationMsg, setEnquiryValidationMsg] = useState("");
  const [isEnquiryValid, setIsEnquiryValid] = useState(false);

  // Helper function to format number to 2 decimal places
  const formatToTwoDecimals = (value) => {
    if (value === null || value === undefined || isNaN(value)) return 0;
    return Math.round((parseFloat(value) + Number.EPSILON) * 100) / 100;
  };

  // Validate purchase number
  const checkjobnumber = debounce(async (number) => {
    if (!number) {
      setEnquiryValidationMsg("");
      setIsEnquiryValid(false);
      return;
    }

    // Remove the regex validation or modify it to be more permissive
    // Only check if the string is not empty and doesn't contain only whitespace
    if (!number.trim()) {
      setEnquiryValidationMsg("❌ Job number cannot be empty");
      setIsEnquiryValid(false);
      return;
    }

    try {
      const response = await axios.get(`${BASE_URL}bom/checkJobNumber/${encodeURIComponent(jobnumber)}`, {
        headers: authHeader(),
      });

      if (response.data === true) {
        setEnquiryValidationMsg("❌ This job number already exists.");
        setIsEnquiryValid(false);
      } else {
        setEnquiryValidationMsg("✅ This job number is available.");
        setIsEnquiryValid(true);
      }
    } catch (error) {
      setEnquiryValidationMsg("❌ Error validating job number.");
      setIsEnquiryValid(false);
    }
  }, 400);

  useEffect(() => {
    if (jobnumber) {
      checkjobnumber(jobnumber);
    }
  }, [jobnumber]);

  const handleSearchChangePumpRawSemiProduct = debounce((inputValue) => {
    setPumpRawSemiProductSearch(inputValue);
  }, 500);

  const getPumpRawSemiProductProductData = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}product/page/ptype/0/10/desc/id/1/Raw Material, Semi Finished,Services/${PumpRawSemiProductSearch || encodeURIComponent(" ")}`,
        { headers: authHeader() }
      );
      const PumpRawSemiProducts = response.data.Index || response.data.data;
      setPumpRawSemiProductOptions(
        PumpRawSemiProducts.map((product) => ({
          value: product.id,
          label: `${product.description} - Part No.: ${product.partno} - MOC: ${product.moc} - Size: ${product.size}`,
          uom: product.unitofmeasurement || '',
          pumprequiredquantity: product.pumprequiredquantity || '',
          rate: product.rate || '',
          partno: product.partno || '',
          moc: product.moc || '',
          size: product.size || '',
        }))
      );
    } catch (error) {
      console.error('Error fetching product data:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to fetch product data.',
      });
    }
  };

  useEffect(() => {
    getPumpRawSemiProductProductData();
  }, [PumpRawSemiProductSearch]);

  const handlePumpRawSemiProductSelect = (selected) => {
    setSelectedPumpRawSemiProduct(selected);
    if (selected) {
      const quantity = selected.pumprequiredquantity ? parseFloat(selected.pumprequiredquantity) : '';
      const rate = selected.rate ? parseFloat(selected.rate) : '';
      const amount = (quantity && rate) ? formatToTwoDecimals(quantity * rate) : 0;

      setproductTableRaw([
        ...productTableRaw,
        {
          PumpRawSemiProduct: selected,
          partname: '',
          uom: selected.uom,
          pumprequiredquantity: quantity === '' ? '' : quantity,
          rate: rate === '' ? '' : rate,
          amount: amount,
          partno: selected.partno,
          moc: selected.moc,
          size: selected.size,
          description: selected.label.split(' - ')[0],
        },
      ]);
    }
  };

  const handleRawSemiInputChanges = (index, field, value) => {
    const updatedRows = [...productTableRaw];
    // Allow empty string, don't convert to 0 immediately
    const parsedValue = value === '' ? '' : parseFloat(value) || 0;

    updatedRows[index][field] = parsedValue;

    if (field === 'pumprequiredquantity' || field === 'rate') {
      const pumprequiredquantity = updatedRows[index].pumprequiredquantity === '' ? 0 : parseFloat(updatedRows[index].pumprequiredquantity) || 0;
      const rate = updatedRows[index].rate === '' ? 0 : parseFloat(updatedRows[index].rate) || 0;
      updatedRows[index].amount = formatToTwoDecimals(pumprequiredquantity * rate);
    }

    setproductTableRaw(updatedRows);
  };

  const handleRawSemiRemoveRow = (index) => {
    const updatedRows = productTableRaw.filter((_, rowIndex) => rowIndex !== index);
    setproductTableRaw(updatedRows);
  };

  const RawSemicalculateTotalCost = () => {
    const total = productTableRaw.reduce((total, row) => total + (row.amount || 0), 0);
    return formatToTwoDecimals(total);
  };

  const getFinishedProduct = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}product/page/ptype/0/10/desc/id/1/Finished/${finishedproductSearch.length > 0 ? finishedproductSearch : encodeURIComponent(" ")}`,
        { headers: authHeader() }
      );
      const finishedproducts = response.data.Index || response.data.data;
      setfinishedproductOptions(
        finishedproducts.map((finishedproduct) => ({
          value: finishedproduct.id,
          label: finishedproduct.description,
          partno: finishedproduct.partno || '',
          size: finishedproduct.size || '',
          labourcharges: finishedproduct.labourcharges || 0,
        }))
      );
    } catch (error) {
      console.error('Error fetching finishedproduct data', error);
    }
  };

  const handleFinishedProductChange = (selected) => {
    setSelectedfinishedproduct(selected);
    setpartno(selected?.partno || '');
    setsize(selected?.size || '');
    setlabourcharges(selected?.labourcharges ? selected.labourcharges : '');
  };

  const handleSearchChangefinishedproduct = debounce((inputValue) => {
    setfinishedproductSearch(inputValue);
  }, 500);

  useEffect(() => {
    getFinishedProduct();
  }, [finishedproductSearch]);

  const calculateLabourChargeAmount = () => {
    const totalCost = RawSemicalculateTotalCost();
    const labourPercent = labourcharges === '' ? 0 : parseFloat(labourcharges) || 0;
    const labourAmount = (totalCost * labourPercent) / 100;
    return formatToTwoDecimals(labourAmount);
  };

  const calculateGrandTotal = () => {
    const total = RawSemicalculateTotalCost() + calculateLabourChargeAmount();
    return formatToTwoDecimals(total);
  };

  const handleSubmit = async () => {
    if (!isEnquiryValid) {
      Swal.fire("Error", "Please enter a valid job number", "error");
      return;
    }
    if (RawSemicalculateTotalCost() === 0) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'Total cost cannot be zero.',
      });
      return;
    }

    const pumpbomrawmaterialtotalcost = RawSemicalculateTotalCost();
    const grandtotalpump = calculateGrandTotal();

    const payload = {
      finalfinishedproduct: selectedfinishedproduct ? { id: selectedfinishedproduct.value } : null,
      bomPumpPartsItemsRawSemiService: productTableRaw.map(row => ({
        product: { id: row.PumpRawSemiProduct?.value },
        description: row.description,
        partname: row.partname,
        partno: row.partno,
        moc: row.moc,
        size: row.size,
        pumprequiredquantity: row.pumprequiredquantity === '' ? 0 : row.pumprequiredquantity,
        uom: row.uom,
        rate: row.rate === '' ? 0 : row.rate,
        amount: formatToTwoDecimals(row.amount),
      })),
      pumpbomrawmaterialtotalcost: formatToTwoDecimals(pumpbomrawmaterialtotalcost),
      labourcharges: formatToTwoDecimals(calculateLabourChargeAmount()),
      labourchargespercentage: labourcharges === '' ? 0 : parseFloat(labourcharges) || 0,
      grandtotalpump: formatToTwoDecimals(grandtotalpump),
      bomtype: 'Pump',
      jobnumber,
      partno,
      size,
    };

    console.log('payload', payload);

    try {
      const response = await axios.post(`${BASE_URL}bom`, payload, {
        headers: {
          ...authHeader(),
          'Content-Type': 'application/json',
        },
      });

      console.log('bom api', response);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'added successfully!',
      }).then(() => {
        navigate(`/bomindex/1`);
      });

    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to save the part.',
      });
    }
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6> BILL OF MATERIAL </h6>
          <Link to="/bomindex/1">
            <button className="button-70">BACK</button>
          </Link>
        </Card.Header>
        <Card.Body>
          <Form>
            <Row>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Product Name (Finished):</Form.Label>
                  <Select
                    options={finishedproductOptions}
                    onChange={handleFinishedProductChange}
                    onInputChange={handleSearchChangefinishedproduct}
                    value={selectedfinishedproduct}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                  />
                </Form.Group>
              </Col>

              <Col md="6">
                <Form.Group>
                  <Form.Label>Part Number</Form.Label>
                  <Form.Control type="text" value={partno} readOnly />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Size</Form.Label>
                  <Form.Control type="text" value={size} readOnly />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Job Number *</Form.Label>
                  <Form.Control
                    type="text"
                    value={jobnumber}
                    onChange={(e) => setjobnumber(e.target.value)}
                    isInvalid={!!enquiryValidationMsg.includes("❌")}
                    isValid={!!enquiryValidationMsg.includes("✅")}
                  />
                  <Form.Control.Feedback
                    type={enquiryValidationMsg.includes("✅") ? "valid" : "invalid"}
                  >
                    {enquiryValidationMsg}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <hr />
            <Form.Group>
              <Form.Label>Select Raw/Semi/Service Products :</Form.Label>
              <Select
                options={PumpRawSemiProductOptions}
                onChange={handlePumpRawSemiProductSelect}
                onInputChange={handleSearchChangePumpRawSemiProduct}
                value={selectedPumpRawSemiProduct}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: base => ({ ...base, zIndex: 9999 })
                }}
              />
            </Form.Group>
            <br />
            <div className="table-responsive">
              <Table bordered>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Part Name</th>
                    <th>Part No.</th>
                    <th>MOC</th>
                    <th>Size</th>
                    <th>QTY</th>
                    <th>unit of measurement</th>
                    <th>Rate</th>
                    <th>Amount</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {productTableRaw.map((row, index) => (
                    <tr key={index}>
                      <th>{index + 1}</th>
                      <td>{row.PumpRawSemiProduct.label.split(' - ')[0]}</td>
                      <td>{row.partno}</td>
                      <td>{row.moc}</td>
                      <td>{row.size}</td>
                      <td>
                        <Form.Control
                          className="quantity"
                          type="number"
                          value={row.pumprequiredquantity === '' ? '' : row.pumprequiredquantity}
                          onChange={(e) => handleRawSemiInputChanges(index, 'pumprequiredquantity', e.target.value)}
                          min="0"
                          step="0.01"
                          placeholder="Enter quantity"
                        />
                      </td>
                      <td>{row.uom}</td>
                      <td>
                        <Form.Control
                          className="rate"
                          type="number"
                          value={row.rate === '' ? '' : row.rate}
                          onChange={(e) => handleRawSemiInputChanges(index, 'rate', e.target.value)}
                          min="0"
                          step="0.01"
                          placeholder="Enter rate"
                        />
                      </td>
                      <td>{row.amount.toFixed(2)}</td>
                      <td>
                        <Button variant="danger" onClick={() => handleRawSemiRemoveRow(index)}>X</Button>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan="7" className="text-end"><strong>Total Cost:</strong></td>
                    <td colSpan="2"><strong>{RawSemicalculateTotalCost().toFixed(2)}</strong></td>
                  </tr>
                  <tr>
                    <td colSpan="7" className="text-end"><strong>Labour Charges (%)</strong></td>
                    <td colSpan="2">
                      <Form.Control
                        type="number"
                        value={labourcharges === '' ? '' : labourcharges}
                        onChange={(e) => setlabourcharges(e.target.value === '' ? '' : parseFloat(e.target.value) || 0)}
                        min="0"
                        max="100"
                        step="0.01"
                        placeholder="Enter percentage"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="7" className="text-end"><strong>Labour amount: ₹ </strong></td>
                    <td colSpan="2">
                      {calculateLabourChargeAmount().toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="7" className="text-end"><strong>Grand Total:</strong></td>
                    <td colSpan="2"><strong>{calculateGrandTotal().toFixed(2)}</strong></td>
                  </tr>
                </tbody>
              </Table>
            </div>
            <Button variant="primary" onClick={handleSubmit}>Submit</Button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default BomPumpCreate;